import * as yup from 'yup';

export const codeValidation = yup
  .string()
  .max(6)
  .required('Verification code is required');
